export default {
  fluidManufacturerID: { field: 'fluidManufacturerID', fieldType: 'numeric' },
  fluidManufacturerName: { field: 'fluidManufacturerName', fieldType: 'text', label: 'Manufacturer Name' },
  isActive: { field: 'isActive', fieldType: 'boolean' },
  isDeleted: { field: 'isDeleted', fieldType: 'boolean' }
};
